var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.$_can("companies.store")
          ? _c(
              "div",
              { staticClass: "col-3 text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/companies/create", tag: "button" }
                  },
                  [_vm._v("\n        ADD COMPANY\n      ")]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 filters-field" }, [
          _c("span", [_vm._v("Filters:")]),
          _vm._v(" "),
          _vm.filtersLoaded
            ? _c("span", [
                _vm.filters.carrier.length
                  ? _c(
                      "span",
                      _vm._l(_vm.filters.carrier, function(carrier) {
                        return _c(
                          "span",
                          {
                            key: carrier,
                            staticClass: "filter-item btn btn-filter"
                          },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("carrier", carrier)
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Carrier: " +
                                _vm._s(
                                  _vm.carriers.find(function(el) {
                                    return el.id === carrier
                                  }).name
                                )
                            )
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.companyStatus.length
                  ? _c(
                      "span",
                      _vm._l(_vm.filters.companyStatus, function(
                        companyStatus
                      ) {
                        return _c(
                          "span",
                          {
                            key: companyStatus,
                            staticClass: "filter-item btn btn-filter"
                          },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter(
                                    "companyStatus",
                                    companyStatus
                                  )
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Status: " +
                                _vm._s(
                                  _vm.companyStatuses.find(function(el) {
                                    return el.id === companyStatus
                                  }).name
                                )
                            )
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.tags && _vm.filters.tags.length && _vm.tags
                  ? _c(
                      "span",
                      _vm._l(_vm.filters.tags, function(tag) {
                        return _c(
                          "span",
                          {
                            key: tag,
                            staticClass: "filter-item btn btn-filter"
                          },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("tags", tag)
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Tag: " +
                                _vm._s(
                                  _vm.tags.find(function(el) {
                                    return el.id === tag
                                  }).name
                                ) +
                                " "
                            )
                          ]
                        )
                      })
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary add-filters",
              on: {
                click: function($event) {
                  _vm.showFilters = true
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus filter-icon" })]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.companies
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _c("thead", { staticClass: "m-table__heading" }, [
                _c("tr", [
                  _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "name" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("name")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Name\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["name"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Address")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Deposit")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Min Hours")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.companies, function(company) {
                    return _c(
                      "tr",
                      {
                        key: company.id,
                        staticClass: "pointer",
                        on: {
                          mouseup: function($event) {
                            _vm.$_can("companies.show") &&
                              _vm.view($event, company.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(company.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(company.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(company.address))]),
                        _vm._v(" "),
                        _c("td", [_vm._v("$" + _vm._s(company.deposit_value))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(company.minimum_hours))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(company.status.name))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.companies && !_vm.companies.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "6" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Carriers")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.carriers,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.carrier,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "carrier",
                                              $$v
                                            )
                                          },
                                          expression: "filters.carrier"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Company Status")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.companyStatuses,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "hide-selected": true,
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.companyStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "companyStatus",
                                              $$v
                                            )
                                          },
                                          expression: "filters.companyStatus"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Tags")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        staticClass: "w-100",
                                        attrs: {
                                          options: _vm.tags,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "track-by": "id",
                                          label: "name"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag p-0 bg-transparent"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      [
                                                        _c("tag-color", {
                                                          attrs: {
                                                            color:
                                                              props.option.color
                                                                .name,
                                                            name:
                                                              props.option.name
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "option",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "option__desc"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "option__title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                ) +
                                                                "\n                            "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.tags,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "tags", $$v)
                                          },
                                          expression: "filters.tags"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !(
                              !_vm.filters.carrier.length &&
                              !_vm.filters.companyStatus.length &&
                              !_vm.filters.tags.length
                            )
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _c("h1", [_vm._v("Companies")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddb995b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddb995b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/Companies.vue
// module id = null
// module chunks = 